import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../../components/Button';
import colors from '../../../../components/Button/colors';
import { disableAutoTopup } from './API/api';
import { apiResponseWrapper } from '../../../../utils/apiResponseWrapper';

function AutoTopupDisableModal({ onConfirm, onReject }) {
  const onDisableClick = async () => {
    apiResponseWrapper(await disableAutoTopup());
    onConfirm();
  };

  return (
    <div className={'boo'}>
      <div className={'p-3'}>
        <div className={'H2 '}>Отключение автопополнения</div>
        <div className={'mt-4'}>Вы уверены, что хотите отключить автопополнение кошелька ЕНП?</div>
        <div className={'d-flex flex-wrap mt-3 justify-content-end'}>
          <Button hasWrapper={false} color={colors.WHITE_BLUE} onClick={onDisableClick}>
            Отключить
          </Button>
          <Button hasWrapper={false} onClick={onReject}>
            Оставить автопополнение
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AutoTopupDisableModal;

AutoTopupDisableModal.propTypes = {
  onConfirm: PropTypes.func,
  onReject: PropTypes.func,
};
